<div  class="refresh-user">
  <div class="refresh-user__box loading-mask">
      <span class="refresh-user__box--label">Reloading Profile</span>
  </div>
</div>
